import { MultiAutocomplete } from 'components/UIkit/atoms/Dropdown';

// TODO: remove file in the next steps
export default MultiAutocomplete;
